import React from 'react'
import { arrowIcon } from '../../utils/constant'

const Button = ({className, handler, children}) => {
  return (
    <button className={`custom-button-full ${className}`} onClick={handler}><span> <div className="content">{children}</div> <img src={arrowIcon} alt="arrow" /></span></button>
  )
}

export default Button